import(/* webpackMode: "eager" */ "/app/src/app/[slug]/styles.scss");
;
import(/* webpackMode: "eager", webpackExports: ["SliderRelatedProducts"] */ "/app/src/components/molecules/SliderRelatedProducts/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["NewEquipmentCarouselClient"] */ "/app/src/components/organisms/NewEquipmentCarousel/NewEquipmentCarouselClient.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ProductDetails"] */ "/app/src/components/organisms/ProductDetails/index.tsx");
